(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-is-for-tote-product"]) return;
  try {
    
  document.querySelectorAll('.aif-product-tote').forEach((section) => {
    const hero = section.querySelector('.aif-product-tote__hero');
    section.querySelectorAll('[data-image-url]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!hero) return;
        hero.src = button.dataset.imageUrl;
        hero.removeAttribute('srcset');
        hero.alt = button.dataset.imageAlt || '';
        section.querySelectorAll('[data-image-url]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daymark-colour-mug"] && !Shopify.designMode) return;
  try {
    
  function mountDaymarkMugs(){
    document.querySelectorAll('[data-daymark-mug]').forEach(root=>{
      if(root.dataset.mounted)return;root.dataset.mounted='true';
      const variants=JSON.parse(root.querySelector('[data-dm-variants]').textContent).map(variant=>({...variant,gallery:variant.gallery.sort((a,b)=>a.slot-b.slot)}));
      const image=root.querySelector('.dm-hero'),thumbs=root.querySelector('[data-gallery-thumbnails]'),imageStatus=root.querySelector('[data-image-status]'),formError=root.querySelector('[data-form-error]'),addButton=root.querySelector('.dm-add');
      let activeIndex=0,current=variants.find(v=>String(v.id)===root.querySelector('[data-variant-id]').value),selectionGeneration=0,hoverActive=false;
      function setImage(index){hoverActive=false;activeIndex=index;const item=current.gallery[index];image.hidden=false;image.style.display='';image.removeAttribute('srcset');image.src=item.image;image.alt=item.alt;thumbs.querySelectorAll('.dm-thumb').forEach((button,buttonIndex)=>button.setAttribute('aria-pressed',String(buttonIndex===index)));}
      function renderGallery(){if(!current.gallery.length){thumbs.replaceChildren();image.hidden=true;image.style.display='none';image.removeAttribute('src');imageStatus.textContent='Images for this colour are not available yet.';imageStatus.hidden=false;return;}imageStatus.hidden=true;thumbs.replaceChildren(...current.gallery.map((item,index)=>{const button=document.createElement('button'),thumbnail=document.createElement('img');button.type='button';button.className='dm-thumb';button.setAttribute('aria-label',item.label);button.setAttribute('aria-pressed',String(index===activeIndex));thumbnail.src=item.thumb;thumbnail.alt=item.alt;thumbnail.loading='lazy';button.append(thumbnail);button.addEventListener('click',()=>setImage(index));return button;}));setImage(activeIndex);}
      // January only: sideview is explicit variant gallery slot 2 (original
      // supplier view 3), never the second media of an unrelated colour.
      const janHover=root.dataset.daymarkJanuary==='true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const febHover=root.dataset.daymarkFebRun==='true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      image.addEventListener('mouseenter',()=>{
        if(!(janHover||febHover) || activeIndex!==0 || root.getAttribute('aria-busy')==='true' ||
           current.gallery.length!==4 ||
           (janHover && !current.gallery[1]?.media_id) ||
           (febHover && !current.gallery[1]?.image))return;
        hoverActive=true;
        image.removeAttribute('srcset');
        image.src=current.gallery[1].image;
        image.alt=current.gallery[1].alt;
      });
      image.addEventListener('mouseleave',()=>{
        if(hoverActive){hoverActive=false;setImage(0);}
      });
      function preloadGallery(gallery){return Promise.all(gallery.map(item=>new Promise((resolve,reject)=>{const preload=new Image(),timeout=window.setTimeout(()=>{preload.src='';reject(new Error('Image load timed out'));},15000);preload.onload=()=>{window.clearTimeout(timeout);resolve();};preload.onerror=()=>{window.clearTimeout(timeout);reject(new Error('Image load failed'));};preload.src=item.image;})));}
      function restoreCurrentSelection(){const selected=root.querySelector(`.dm-colour input[value="${current.id}"]`);if(selected)selected.checked=true;}
      function showError(message){formError.textContent=message;formError.hidden=false;}
      function restoreAddState(){addButton.disabled=root.dataset.previewOnly==='true'||!current.available;}
      if(!current){root.dataset.mounted='error';return;}renderGallery();
      root.querySelectorAll('.dm-colour input').forEach(input=>input.addEventListener('change',()=>{
        const v=variants.find(v=>String(v.id)===input.value);if(!v)return;
        const generation=++selectionGeneration;
        
        root.setAttribute('aria-busy','true');imageStatus.textContent='Loading images…';imageStatus.hidden=false;addButton.disabled=true;preloadGallery(v.gallery).then(()=>{if(generation!==selectionGeneration)return;current=v;activeIndex=0;root.querySelector('[data-colour-name]').textContent=v.title;root.querySelector('[data-price]').textContent=v.price;root.querySelector('[data-variant-id]').value=String(v.id);renderGallery();formError.hidden=true;const url=new URL(window.location.href);url.searchParams.set('variant',v.id);history.replaceState(null,'',url);}).catch(()=>{if(generation!==selectionGeneration)return;imageStatus.hidden=true;restoreCurrentSelection();showError('Images could not be loaded. Please try again.');}).finally(()=>{if(generation!==selectionGeneration)return;root.removeAttribute('aria-busy');restoreAddState();});
      }));
      const quantity=root.querySelector('input[name="quantity"]');root.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{quantity.value=Math.max(1,Math.min(99,(parseInt(quantity.value,10)||1)+Number(b.dataset.step)));}));
      root.querySelector('form').addEventListener('submit',event=>{if(root.dataset.previewOnly==='true'){event.preventDefault();return;}const value=Number(quantity.value);if(!Number.isInteger(value)||value<1||value>99){event.preventDefault();const error=root.querySelector('.dm-form-error');error.textContent='Please choose a quantity from 1 to 99.';error.hidden=false;}});
    });
  }
  mountDaymarkMugs();document.addEventListener('shopify:section:load',mountDaymarkMugs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daymark-mug-preview"] && !Shopify.designMode) return;
  try {
    
  function mountDaymarkMugs(){
    document.querySelectorAll('[data-daymark-mug]').forEach(root=>{
      if(root.dataset.mounted)return;root.dataset.mounted='true';
      const variants=JSON.parse(root.querySelector('[data-dm-variants]').textContent).map(variant=>({...variant,gallery:variant.gallery.sort((a,b)=>a.slot-b.slot)}));
      const image=root.querySelector('.dm-hero'),thumbs=root.querySelector('[data-gallery-thumbnails]'),imageStatus=root.querySelector('[data-image-status]'),formError=root.querySelector('[data-form-error]'),addButton=root.querySelector('.dm-add');
      let activeIndex=0,current=variants.find(v=>String(v.id)===root.querySelector('[data-variant-id]').value),selectionGeneration=0,hoverActive=false;
      function setImage(index){hoverActive=false;activeIndex=index;const item=current.gallery[index];image.hidden=false;image.style.display='';image.removeAttribute('srcset');image.src=item.image;image.alt=item.alt;thumbs.querySelectorAll('.dm-thumb').forEach((button,buttonIndex)=>button.setAttribute('aria-pressed',String(buttonIndex===index)));}
      function renderGallery(){if(!current.gallery.length){thumbs.replaceChildren();image.hidden=true;image.style.display='none';image.removeAttribute('src');imageStatus.textContent='Images for this colour are not available yet.';imageStatus.hidden=false;return;}imageStatus.hidden=true;thumbs.replaceChildren(...current.gallery.map((item,index)=>{const button=document.createElement('button'),thumbnail=document.createElement('img');button.type='button';button.className='dm-thumb';button.setAttribute('aria-label',item.label);button.setAttribute('aria-pressed',String(index===activeIndex));thumbnail.src=item.thumb;thumbnail.alt=item.alt;thumbnail.loading='lazy';button.append(thumbnail);button.addEventListener('click',()=>setImage(index));return button;}));setImage(activeIndex);}
      // January only: sideview is explicit variant gallery slot 2 (original
      // supplier view 3), never the second media of an unrelated colour.
      const janHover=root.dataset.daymarkJanuary==='true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      image.addEventListener('mouseenter',()=>{
        if(!janHover || activeIndex!==0 || root.getAttribute('aria-busy')==='true' ||
           current.gallery.length!==4 || !current.gallery[1]?.media_id)return;
        hoverActive=true;
        image.removeAttribute('srcset');
        image.src=current.gallery[1].image;
        image.alt=current.gallery[1].alt;
      });
      image.addEventListener('mouseleave',()=>{
        if(hoverActive){hoverActive=false;setImage(0);}
      });
      function preloadGallery(gallery){return Promise.all(gallery.map(item=>new Promise((resolve,reject)=>{const preload=new Image(),timeout=window.setTimeout(()=>{preload.src='';reject(new Error('Image load timed out'));},15000);preload.onload=()=>{window.clearTimeout(timeout);resolve();};preload.onerror=()=>{window.clearTimeout(timeout);reject(new Error('Image load failed'));};preload.src=item.image;})));}
      function restoreCurrentSelection(){const selected=root.querySelector(`.dm-colour input[value="${current.id}"]`);if(selected)selected.checked=true;}
      function showError(message){formError.textContent=message;formError.hidden=false;}
      function restoreAddState(){addButton.disabled=root.dataset.previewOnly==='true'||!current.available;}
      if(!current){root.dataset.mounted='error';return;}renderGallery();
      root.querySelectorAll('.dm-colour input').forEach(input=>input.addEventListener('change',()=>{
        const v=variants.find(v=>String(v.id)===input.value);if(!v)return;
        const generation=++selectionGeneration;
        
        root.setAttribute('aria-busy','true');imageStatus.textContent='Loading images…';imageStatus.hidden=false;addButton.disabled=true;preloadGallery(v.gallery).then(()=>{if(generation!==selectionGeneration)return;current=v;activeIndex=0;root.querySelector('[data-colour-name]').textContent=v.title;root.querySelector('[data-price]').textContent=v.price;root.querySelector('[data-variant-id]').value=String(v.id);renderGallery();formError.hidden=true;const url=new URL(window.location.href);url.searchParams.set('variant',v.id);history.replaceState(null,'',url);}).catch(()=>{if(generation!==selectionGeneration)return;imageStatus.hidden=true;restoreCurrentSelection();showError('Images could not be loaded. Please try again.');}).finally(()=>{if(generation!==selectionGeneration)return;root.removeAttribute('aria-busy');restoreAddState();});
      }));
      const quantity=root.querySelector('input[name="quantity"]');root.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{quantity.value=Math.max(1,Math.min(99,(parseInt(quantity.value,10)||1)+Number(b.dataset.step)));}));
      root.querySelector('form').addEventListener('submit',event=>{if(root.dataset.previewOnly==='true'){event.preventDefault();return;}const value=Number(quantity.value);if(!Number.isInteger(value)||value<1||value>99){event.preventDefault();const error=root.querySelector('.dm-form-error');error.textContent='Please choose a quantity from 1 to 99.';error.hidden=false;}});
    });
  }
  mountDaymarkMugs();document.addEventListener('shopify:section:load',mountDaymarkMugs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daymark-white-mug-preview"]) return;
  try {
    
  document.querySelectorAll('[data-daymark-white-mug]').forEach(root=>{
    if(root.dataset.mounted)return;root.dataset.mounted='true';
    const hero=root.querySelector('.dm-white__hero');
    const buttons=Array.from(root.querySelectorAll('[data-white-thumb]'));
    let activeIndex=0,hoverActive=false;
    const januaryHover=root.dataset.daymarkJanuary==='true' &&
      buttons.length===4 && buttons[1].dataset.alt.startsWith('DAYMARK January ') &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const februaryHover=root.dataset.daymarkFebRun==='true' &&
      buttons.length===4 && buttons[1].dataset.alt.endsWith('| Official front') &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function setImage(index){
      hoverActive=false;activeIndex=index;
      const button=buttons[index];hero.removeAttribute('srcset');
      hero.src=button.dataset.image;hero.alt=button.dataset.alt;
      buttons.forEach((item,j)=>item.setAttribute('aria-pressed',String(j===index)));
    }
    buttons.forEach((button,index)=>button.addEventListener('click',()=>setImage(index)));
    hero.addEventListener('mouseenter',()=>{
      if(!(januaryHover||februaryHover) || activeIndex!==0)return;
      hoverActive=true;hero.removeAttribute('srcset');
      hero.src=buttons[1].dataset.image;hero.alt=buttons[1].dataset.alt;
    });
    hero.addEventListener('mouseleave',()=>{
      if(hoverActive){hoverActive=false;setImage(0);}
    });
    const quantity=root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{quantity.value=Math.max(1,Math.min(99,(parseInt(quantity.value,10)||1)+Number(button.dataset.step)));}));
    root.querySelector('form').addEventListener('submit',event=>event.preventDefault());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["initial-reactions-tote"]) return;
  try {
    
  document.querySelectorAll('.reaction-tote').forEach((section) => {
    const hero = section.querySelector('.reaction-tote__hero');
    section.querySelectorAll('[data-image-url]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!hero) return;
        hero.src = button.dataset.imageUrl;
        hero.removeAttribute('srcset');
        hero.alt = button.dataset.imageAlt || '';
        section.querySelectorAll('[data-image-url]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
